//Include Both Helper File with needed methods

import { toast } from "react-toastify";
import {
  changePasswordService,
  resetPasswordService,
  sendOtpService,
  verifyOtpService,
} from "../../../Services/AuthService";
import { userForgetPasswordError, userForgetPasswordSuccess } from "./reducer";

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
    let response;
    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      response = sendOtpService(user);
    }

    const data = await response;

    if (data?.success) {
      dispatch(userForgetPasswordSuccess(data?.message));
      return true;
    }
  } catch (forgetError) {
    dispatch(userForgetPasswordError(forgetError));
  }
};

export const verifyOtpThunk = (user, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      response = verifyOtpService(user);
    }

    const data = await response;

    if (data?.success) {
      dispatch(userForgetPasswordSuccess(data?.message));
      return true;
    } else {
      toast.error(data?.message || "Invalid OTP");
      history("/login");
    }
  } catch (error) {
    dispatch(userForgetPasswordError("OTP verification failed"));
    // toast.error("OTP verification failed");
    history("/login");
    return false;
  }
};



export const resetPasswordThunk = (payload) => async () => {
  try {
    const response = await resetPasswordService(payload);

    if (response?.success) {
      toast.success("Password reset successfully");
      return true;
    }

    toast.error(response?.message || "Password reset failed");
    return false;
  } catch (error) {
    toast.error("Something went wrong");
    return false;
  }
};
